'use client';

import { createContext, useContext } from 'react';

import type { MessageRealtimeEvent } from '@/features/messages/types';
import type { UnreadCount } from './types';

export interface NotificationsContextValue {
  unread: UnreadCount;
  refreshVersion: number;
  isConnected: boolean;
  markSeen: (ids: string[]) => Promise<string[]>;
  rememberSequence: (sequence: number) => void;
  refreshUnread: () => Promise<void>;
  messageRefreshVersion: number;
  subscribeToMessages: (listener: (event: MessageRealtimeEvent) => void) => () => void;
  emitMessageSocketEvent: (event: string, payload: unknown) => void;
  setActiveConversation: (conversationId: string | null) => void;
}

export const NotificationsContext = createContext<NotificationsContextValue | null>(null);

export function useNotifications(): NotificationsContextValue {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotifications must be used inside NotificationsProvider');
  }
  return context;
}
